import { MutableRefObject, ReactNode } from "react";
// 常量
import { SuperFormItemProps } from "../SuperForm/interface";
import { FormInstance } from "antd/lib/form";

/** card表单 */
export interface CardFormProps extends CardHeaderProps, CardFooterProps {
  /** 值 */
  dataSource?: any[];
  /** 默认值 */
  defaultValue?: any[];
  /** 表单配置 */
  formItems?: SuperFormItemProps[];
  /** 是否可以拖动排序 */
  isMoveSort?: boolean;
  /** 是否可以删除 */
  isDelete?: boolean;
  /** 删除文字 */
  deleteText?: ReactNode;
  /** 是否禁用 */
  disabled?: boolean;
  /** 排序字段名 */
  sortFieldName?: string;
  /** 最大数量 */
  maxLength?: number;
  /** 卡片长度超过最大长度时截取确认 */
  sliceModalTitle?: ReactNode | ((value: any) => ReactNode);
  /** 处理修改后的值 */
  formatChangeValue?: (changeFiedname: string, changeFiedvalue: any, options?: any) => any;
  /** 点击删除回调 */
  onDelete?: (values?: any[]) => void;
  /** 点击新增回调 */
  onAdd?: () => boolean;
  /**
   * 字段值更新时触发回调事件
   * @param changedField 当前修改的字段名称
   * @param changedValue 当前字段修改后的值
   * @param changedRowKey 当前行的key
   * @param changedRowValues 当前行的表单值
   * @returns 
   */
  onValuesChange?: (changedField: string, changedValue: any, changedRowKey: number, changedRowValues: any) => void;
  /** 对外方法 */
  actionRef?: MutableRefObject<CardFormActionType>;
};
/** card表单禁用项 */
export interface DisabledItemProps {};
/** card表单头部 */
export interface CardHeaderProps {
  /** 标题 */
  title?: ReactNode;
  /** 副标题 */
  subTitle?: ReactNode;
  /** 提示文字 */
  toolTipText?: ReactNode;
};
/** card表单组 */
export interface CardGroupProps {
  form: FormInstance<any>;
  /** 是否禁用 */
  disabled?: boolean;
  /** 分组key */
  groupKey: number;
  /** 值 */
  value?: any;
  /** 表单配置 */
  formItems?: SuperFormItemProps[];
  /** 是否可以删除 */
  isDelete?: boolean;
  /** 删除文字 */
  deleteText?: ReactNode;
  /** 处理表单修改后的值 */
  formatChangeValue?: (changeFiedname: string, changeFiedvalue: any, options: any) => any;
  /** 卡片组值修改回调 */
  onChange?: (groupKey: number, groupValues: any, changeFiedname: string, changeFiedvalue: any) => void;
  /** 点击删除回调 */
  onDelete?: (groupKey: number[]) => void;
};
/** card表单项 */
export interface CardFormItemProps extends SuperFormItemProps {
  form: FormInstance<any>;
  /** 分组Key */
  groupKey: any;
  /** 值 */
  value?: any;
  /** 分组数据 */
  groupValue?: any;
  /** 是否禁用 */
  disabled?: boolean;
  /** 表单值修改回调 */
  onChange: (name: string, value: any, associationNames?: string[], options?: any) => void;
};
/** card表单底部 */
export interface CardFooterProps {
  /** 添加图标 */
  addIcon?: ReactNode;
  /** 添加一行文字 */
  addText?: ReactNode;
  /** 是否显示添加按钮 */
  showAdd?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 数量达到最大行后显示提示文字 */
  maxLengthText?: ReactNode;
  /** 点击新增回调 */
  onAdd?: () => void;
};

export const ID_KEY = 'key';
/** 分组名称 */
export const CARD_FORM_NAME = 'cardFromName';

interface CardFormAction {
  /**
   * 添加卡片
   * @param data 卡片初始值 
   * @returns 
   */
  add: (data: any) => void;
  /**
   * 删除一个卡片
   * @param record 当前卡片数据
   * @returns 
   */
  delete: (record: any) => void;
  /**
   * 获取卡片数据
   * @param isEffective 是否过滤已删除数据
   * @returns 
   */
  getCardData: (isEffective?: boolean) => any[];
  /** 提交 */
  submit: () => Promise<any[] | false>;
  /** 清空卡片数据 */
  empty: () => void;
  /**
   * 修改表单的值(单个卡片单项)
   * @param groupKey 当前卡片的key
   * @param field 字段名
   * @param value 字段值
   * @returns 
   */
  setFieldValue: (groupKey: number, field: string, value: any) => void;
  /**
   * 修改表单的值(单个卡片多项)
   * @param groupKey 当前卡片的key
   * @param values 当前卡片要修改的表单数据
   * @returns 
   */
  setFieldsValue: (groupKey: number, values: any) => void;
  /**
   * 批量修改所有行单项数据
   * @param field 字段名
   * @param value 字段值
   * @returns 
   */
  /** 设置每个卡片的某个值 */
  setRowsValue: (fieldname: string, value: any) => void;
};

export type CardFormActionType = CardFormAction | undefined;
